/**
 * Renders the header right component with notification and help button.
 *
 * @return {JSX.Element} The rendered header right component
 */

const HeaderRight = () => {
  return (
    <>
      <div className="HeaderRight_Wrapper flex items-center gap-3">
        {/* <Notification />
        <Tooltip title={TOOLTIPTEXT.announcement}>
          <Link
            to={routingConstants.clientAnnouncement}
            className={`group flex h-[44px] w-[56px] items-center justify-center select-none rounded-lg hover:bg-primary hover:text-white ${activePage == 'announcement' ? 'bg-primary' : 'bg-grey'} transition-linear`}
          >
            <LatestAnnouncementIcon
              cls={`h-[25px] w-[25px] ${activePage == 'announcement' ? '!text-white group-hover:hidden' : '!text-primary group-hover:hidden'}`}
            />
            <LatestAnnouncementIcon
              cls={`h-[25px] w-[25px] hidden group-hover:block !text-white`}
            />
          </Link>
        </Tooltip> */}
        {/* <Help /> */}
      </div>
    </>
  );
};

export default HeaderRight;
